import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

const AboutMePage = () => {
    const image = 'assets/jm_pic02.jpg';

    return (
        <Box
            sx={{
                backgroundImage: 'linear-gradient(to bottom, #120222, #095c79)',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 4,
            }}
        >
            <Stack spacing={4} sx={{ maxWidth: 600, textAlign: 'center', alignItems: 'center' }}>
                <Box
                    component="img"
                    src={image}
                    sx={{
                        width: 150,
                        height: 150,
                        objectFit: 'cover',
                        borderRadius: '50%',
                        border: '5px solid white',
                    }}
                />
                <Typography variant="h3" sx={{ fontWeight: 'bold', color: 'white' }}>
                    About Me
                </Typography>

                <Divider
                    variant="middle"
                    sx={{
                        borderColor: 'white',
                        width: '80%',
                        alignSelf: 'center',
                        opacity: 0.7,
                    }}
                />

                {/* Intro / Headline */}
                <Typography variant="h6" sx={{ color: '#B0BEC5' }}>
                    Hi, I’m Jia Ming, a software developer who loves transforming ideas into robust, scalable applications. 
                </Typography>

                <Divider
                    variant="middle"
                    sx={{
                        borderColor: 'white',
                        width: '80%',
                        alignSelf: 'center',
                        opacity: 0.7,
                    }}
                />

                {/* Expanded Body Text */}
                <Typography variant="body1" sx={{ color: '#B0BEC5', lineHeight: 1.8 }}>
                    My work revolves around crafting efficient, reliable solutions that address real-world problems. 
                    With a background in full-stack development and AI, I strive to integrate applications powered 
                    by robust model deployments to achieve scalable and powerful AI solutions. I enjoy exploring new 
                    technologies, tackling complex challenges, and continuously refining my skills in today’s rapidly 
                    evolving tech landscape.
                </Typography>

                <Typography variant="body1" sx={{ color: '#B0BEC5', lineHeight: 1.8 }}>
                    Outside of coding, I have an avid passion for the outdoors and sports. My favourite would be exploring the marine world through scuba diving, 
                    and I’m always up for a game of table tennis or badminton in my free time.
                </Typography>
            </Stack>
        </Box>
    );
};

export default AboutMePage;